// @ts-nocheck
import FastFormulaParser from 'fast-formula-parser';

export type IFormulaParser = FastFormulaParser;

export default FastFormulaParser;
